import { Component, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberWithoutCommas'
})

export class NumberWithoutCommasPipeComponent implements PipeTransform {

  transform(value: any): any {
    if (typeof value === 'number') {
      return value.toString().replace(/,/g, '');
    }
    return value;
  }

}